import { Injectable } from '@angular/core';
import PubNub from 'pubnub';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';


@Injectable({
    providedIn: 'root',
})
export class PubnubService {
    public showCasePubnumInstance: any;
    constructor() { }

    showCasePubnumInstantiateAndSubscribe(pubkey: string, subkey: string, channelId: any, uid: any) {
        this.showCasePubnumInstance = new PubNub({
            publishKey: pubkey,
            subscribeKey: subkey,
            uuid: uid
        });
        this.addShowCaseListners(channelId);
    }

    publish(channelId: string, msg: any, pubnubInstance = this.showCasePubnumInstance) {
        pubnubInstance.publish(
            {
                channel: channelId,
                message: msg,
                callback: function (response: any) {
                    if (response.error) {
                        // Channel may not exist or there was an error publishing the presence message
                    } else {
                        // Channel exists, proceed with subscription
                        pubnubInstance.subscribe({
                            channels: channelId,
                            message: function (message: any) {
                                console.log('Received Message:', message);
                            },
                            error: function (error: any) {
                                console.error('Error:', error);
                            }
                        });
                    }
                }
            },
            function (status: any, response: any) {
                if (status.error) {
                    console.log(status);
                } else {
                    console.log("message Published w/ timetoken", response.timetoken);
                }
            }
        );
        // pubnubInstance.subscribe({
        //     channels: [channelId],
        //     withPresence: true,
        // });
    }

    removeObserver(channelID: any) {
        this.showCasePubnumInstance.unsubscribe({
            channels: [channelID],
            withPresence: true
        });
    }

    addObserver(channelId: any): Observable<any> {
        let self = this;
        return new Observable(function (observer) {
            self.showCasePubnumInstance.addListener({
                message: function (msg: any) {
                    observer.next(msg);
                    // console.log(msg);
                },
                // withPresence: true,
                presence: function (event: any) {
                    var action = event.action;
                    var channelName = event.channel;
                    var occupancy = event.occupancy;
                    var occupantUUID = event.uuid;
                    if (action == 'timeout' || action == 'leave')// || action == 'join') 
                    {
                        event.timeout = true;
                        observer.next(event);
                    }
                },
                error: function (err: any) {
                    console.log(err);
                }
            })
        });

    }

    addShowCaseListners(channelId: any, pubnub = this.showCasePubnumInstance) {
        pubnub.addListener({
            status: function (statusEvent: any) {
                if (statusEvent.category === "PNConnectedCategory") {
                }
            },
            message: function (msg: any) {
            },
            presence: function (obj: any) {
            },
            error: function (err: any) {
                console.log(err);
            }
        });
        if (channelId)
            pubnub.subscribe({
                channels: [channelId],
                withPresence: true,
                presence: function (presenceEvent: any) {
                    // Presence events provide information about clients on the channel
                    console.log('Presence Event:', presenceEvent);
                },
                message: function (message: any) {
                    console.log('Received Message:', message);
                },
                error: function (error: any) {
                    console.error('Error:', error);
                }
            });
    }

    //for testing purpose only!
    leaveChannel(channelID: any) {
        this.showCasePubnumInstance.unsubscribeAll();
        //.unsubscribe({
        //     channels: [channelID],
        //     withPresence: true,
        // });
    }

}